import React from 'react';

const FilterSearchField = ({
  fieldName,
  placeholder = 'Search...',
  setFiltered,
  totalValues,
}) => {
  const [search, setSearch] = React.useState('');

  const handleChange = (e) => {
    setSearch(e.target.value);
    const isObjectArray = totalValues.find((e) => typeof e !== 'string');
    if (isObjectArray) {
      const filtered = totalValues.filter((item) => {
        if (fieldName === 'coaches') {
          return (
            item?.value.toLowerCase().includes(e.target.value.toLowerCase()) ||
            item?.data?.nickName
              ?.toLowerCase()
              .includes(e.target.value.toLowerCase())
          );
        }
        return item?.value.toLowerCase().includes(e.target.value.toLowerCase());
      });

      setFiltered(filtered);
      return;
    }
    const filtered = totalValues.filter((value) => {
      return value.toLowerCase().includes(e.target.value.toLowerCase());
    });
    setFiltered(filtered);
  };
  return (
    <input
      onChange={handleChange}
      placeholder={placeholder}
      style={{
        background: '#F3F4F6',
        border: 'none',
        borderRadius: '6px',
        marginBottom: '10px',
        outline: 'none',
        padding: '8px',
        width: '100%',
      }}
      value={search}
    />
  );
};

export default FilterSearchField;
